import React from 'react';
import "./Footer.css";
import { FaHome,FaPhone, FaMailBulk,FaFacebook, FaLinkedin,FaInstagram } from 'react-icons/fa';
import { Link } from 'react-router-dom';
const footer = () => {
  return (
    <div className='footer'>
        <div className='footer-container'>
            <div className='left'>
                <div className='location'>
                    <FaHome size={20} style={{color:"#fff", marginRight:"2rem"}}/>
                    <div>
                      <p>123 Housing society.</p>
                      <p>Bangladesh</p>
                    </div>
                </div>
                <div className='phone'>
                <h4><FaPhone size={20} style={{color:"#fff", marginRight:"2rem"}}/>
                1-2323-343-23</h4>
                 </div>
                 <div className='mail'>
                <h4><FaMailBulk size={20} style={{color:"#fff", marginRight:"2rem"}}/>
                kartiksharma7648@gmail.com</h4>
                 </div>
            </div>
            <div className='right'>
              <h4>About the Company</h4>
              <p>This is me Kartik Sharma. CEO & Founder of Tycoon. I enjoy discussing new prejects and design challenges</p>
              <div className='social'>
              <FaFacebook size={30} style={{color:"#fff", marginRight:"1rem"}}/>
              <Link className='name' to="www.facebook.com" style={{color:"#fff"}}>Facebook</Link>
              <br/>
              <FaInstagram size={30} style={{color:"#fff", marginRight:"1rem"}}/>
              <Link className='name' to="https://www.instagram.com/kartiksharma2687/" style={{color:"#fff"}}>Instagram</Link>
              <br/>
              <FaLinkedin size={30} style={{color:"#fff", marginRight:"1rem"}}/>
              <Link className='name' to="https://www.linkedin.com/in/kartik-sharma-61b02825a" style={{color:"#fff"}}>linkedin</Link>
              </div>
            </div>
        </div>
    </div>
  )
}

export default footer
